/**
 * @desc 交货单装箱率总计
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inMaster.packingProbabilityTotal.Params, options?: any) {
  return updateResponse(
    http(URL + `/inMaster/packingProbabilityTotal`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
